
import { BACKGROUND_COLOR } from 'interfaces';
import styled from 'styled-components';
import devices from '@/utilities/devices';

export const AppStoreButton = styled.a<{ width?: string }>`
	align-items: center;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	padding: .1rem .5rem;
	transition: .2s;
	width: ${({ width }) => width};
	border: 1px solid ${({ theme }) => `rgba(${theme.color.rgbWhite}, .7)`};

	:hover {
		background: ${({ theme }) => `rgba(${theme.color.rgbWhite}, .2)`};
	}
`;
export const MobileHeroImageContainer = styled.div<{ backgroundImage: string }>`
	background-image: url(${({ backgroundImage }) => backgroundImage});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 0.4375rem;
	display: none;
	margin: 1rem 0;
	position: relative;
	@media screen and (${devices.mobile}) {
		display: block;
		height: 13.75rem;
		width: 100%;
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		display: block;
		height: 21.875rem;
		width: 100%;
	}
`;

export const Separator = styled.div`
	background-color: ${({ theme }) => theme.color.grey};
	height: 1px;
	width: 100%;
`;
// ToDo: delete once pages uses strapi and Text molecule.
export const TextContainer = styled.h3<{ color?: string, textAlign?: string, padding?: string }>`
	color: ${({ color, theme }: any) => color ? theme.color[color] : theme.color.black};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	margin: 0rem 0 .5rem;
	padding: ${({ padding }) => padding ? padding : '2.5rem 4rem'};
	text-align: ${({ textAlign }) => textAlign};

	@media screen and (${devices.mobile}) {
		padding: 1.3rem 0;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		padding: 1.5rem 3rem;
	}
`;

export const Svg = styled.div<{
	color?: any;
	fill?: any;
	circle?: any;
	path?: any;
	stroke?: any;
	size?: {
		height: string;
		width: string;
	}
}>`
	svg {
		width: ${({ size }) => size?.width && size.width};
		height: ${({ size }) => size?.height && size.height};
		fill: ${({ theme, color, fill }: any) => fill ? theme.color[fill] : theme.color[color]};
		circle {
			stroke: ${({ theme, color , circle }: any) => circle ? theme.color[circle] : theme.color[color]} !important;
		}
		g {
			stroke: ${({ theme, color, stroke }: any) => stroke ? theme.color[stroke] : theme.color[color]} !important; ;
		}
		path {
			fill: ${({ theme, color, path }: any) => path ? theme.color[path] : theme.color[color]} !important;
			stroke: ${({ theme, stroke }: any) => stroke && theme.color[stroke]} !important;
		}
	}
`;

export const SpacingWrapper = styled.section<{
	backgroundColor: BACKGROUND_COLOR;
	padding?: string
}>`
	background-color: ${({ theme, backgroundColor }) => theme.color[backgroundColor]};
	> div {
		margin: auto;
		max-width: calc(90rem - ((10.15rem - 2rem) * 2));
 		padding: ${({ padding }) => padding ? padding : '6rem 2rem'};
		box-sizing: border-box;
	}

	@media screen and (${devices.mobile}) {
		> div {
			width: 100%;
			padding: 2rem 1rem;
			box-sizing: border-box;
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		> div {
			width: 100%;
			padding: 3rem 2rem;
			box-sizing: border-box;
		}
	}
`;
